import React from 'react';
import Modal from '../Modal/Modal';
import css from './TopbarDesktop.module.css';

const SubscriptionReminderModal = props => {
  const { isOpen, setOpen, history } = props;
  return (
    <Modal
      id='subscription'
      isOpen={isOpen}
      onClose={() => {
        setOpen(false);
      }}
      onManageDisableScrolling={() => {}}
    >
      <div className={css.subsReminderWrapper}>
        <p>You need an active subscription to be able to contact service providers</p>
        <p className={css.subscriptionInfoText} onClick={() => history.push('/prices')}>
          Subcribe in here
        </p>
      </div>
    </Modal>
  );
};

export default SubscriptionReminderModal;
